import script from "./PayWithDiscount.vue?vue&type=script&setup=true&lang=js"
export * from "./PayWithDiscount.vue?vue&type=script&setup=true&lang=js"

import "./PayWithDiscount.vue?vue&type=style&index=0&id=609b8405&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-609b8405"]])

export default __exports__